"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    assessmentAnalysis: {
        title: 'Item Analysis',
        legend: 'Class Performance per item',
        vocabLegend: 'Percentage of students who earned a check',
        word: 'Word',
        ariaLabel: 'assessment analysis for {{title}}',
    },
};
